<template>
  <v-app-bar
    app
    color="primary"
    dark
    clipped-left
  >
    <v-app-bar-nav-icon
      v-if="$auth.isAuthenticated && $auth.hasRole('admin')"
      @click.stop="$emit('toggle-drawer')"
    ></v-app-bar-nav-icon>

    <v-img
      alt="Logo de Condorcet"
      contain
      src="https://cdn.ecampus-hainaut.be/logos/logo-condorcet-transparent.png"
      transition="slide-x-transition"
      :max-width="$vuetify.breakpoint.smAndDown ? 138 : 157.70"
    ></v-img>

    <v-spacer></v-spacer>

    <the-account-menu v-if="$auth.isAuthenticated"></the-account-menu>

    <v-btn
      v-else
      :text="!viewIsMobile"
      :icon="viewIsMobile"
      @click="$auth.loginRedirect"
    >
      <v-icon :left="!viewIsMobile">mdi-login</v-icon>

      <span v-if="!viewIsMobile">Se connecter</span>
    </v-btn>
  </v-app-bar>
</template>

<script>
import TheAccountMenu from './TheAccountMenu.vue';

export default {
  name: 'TheAppBar',

  components: {
    TheAccountMenu,
  },

  computed: {
    viewIsMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
